<template>
  <div>
    <b-col cols="12" class="pb-2">
      <vue-good-table
        :columns="fields"
        :rows="items"
        :search-options="{ enabled: true, externalQuery: searchTerm }"
        :pagination-options="{ enabled: true, perPage: perPage }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Action -->
          <span v-if="props.column.field === 'action'">
            <span>
              <a href="#" @click="showView('modal-view', props.row)">
                <feather-icon variant="link" icon="EyeIcon" class="mr-50"
              /></a>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ $t("showing") }} </span>
              <b-form-select
                v-model="perPage"
                :options="['10', '50', '100']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap">
                {{ $t("entries") }}
              </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="perPage"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
      <b-modal id="modal-view" title="View Company" size="xl" hide-footer>
        <TabModalCompanyDetai :taxCode="taxCode" />
      </b-modal>
    </b-col>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import Select2 from "v-select2-component";
import {
  ref,
  reactive,
  watch,
  computed,
  onUnmounted,
} from "@vue/composition-api";

import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { VueGoodTable } from "vue-good-table";
// import "@core/scss/vue/libs/vue-good-table.scss";
import companyManagerStoreModule from "./companyManagerStoreModule";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import store from "@/store";

export default {
  components: {
    vSelect,
    FeatherIcon,
    ValidationProvider,
    ValidationObserver,
    Select2,
    TabModalCompanyDetai: () => import("./TabModalCompanyDetai"),
    VueGoodTable,
  },
  watch: {
    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [
          {
            label: this.$i18n.t("taxCode"),
            field: "tax_code",
            filterOptions: { enabled: true, placeholder: "ID" },
            disabled: true,
            autoIncrement: true,
          },
          {
            field: "name",
            label: this.$i18n.t("name"),
            filterOptions: { enabled: true, placeholder: "Name" },
            required: true,
            sortable: false,
          },
          {
            field: "address",
            label: this.$i18n.t("address"),
            filterOptions: { enabled: true, placeholder: "Name" },
            required: true,
            sortable: false,
          },
          {
            field: "action",
            label: this.$i18n.t("Actions"),
            width: "100px",
            tdClass: "text-center",
            sortable: false,
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  setup(props, ctx) {
    const { t } = useI18nUtils();
    const items = ref([]);
    const fields = reactive([
      {
        label: t("taxCode"),
        field: "tax_code",
        filterOptions: { enabled: true, placeholder: "ID" },
        disabled: true,
        autoIncrement: true,
      },
      {
        field: "name",
        label: t("name"),
        filterOptions: { enabled: true, placeholder: "Name" },
        required: true,
        sortable: false,
      },
      {
        field: "address",
        label: t("address"),
        filterOptions: { enabled: true, placeholder: "Name" },
        required: true,
        sortable: false,
      },
      {
        field: "action",
        label: t("actions"),
        width: "100px",
        tdClass: "text-center",
        sortable: false,
      },
    ]);

    const totalItem = ref(0);
    const permisItems = ref([]);
    const perPage = ref(10);
    const searchQuery = ref("");
    const searchTerm = ref("");
    const taxCode = ref("");
    const CHAT_APP_STORE_MODULE_NAME = "company-manager";

    // Register module
    if (!store.hasModule(CHAT_APP_STORE_MODULE_NAME))
      store.registerModule(
        CHAT_APP_STORE_MODULE_NAME,
        companyManagerStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CHAT_APP_STORE_MODULE_NAME))
        store.unregisterModule(CHAT_APP_STORE_MODULE_NAME);
    });

    const fetchCompanyAll = () => {
      store.dispatch("company-manager/fetchCompanyAll").then((response) => {
        items.value = response.data.result;
        totalItem.value = response.data.meta.total;
      });
    };

    // computed(() => )

    const showView = (modal_id, row) => {
      // this.$bvModal.show(modal_id);
      ctx.root.$bvModal.show(modal_id);
      taxCode.value = row.tax_code;
    };

    fetchCompanyAll();

    return {
      // value
      items,
      fields,
      totalItem,
      permisItems,
      perPage,
      searchQuery,
      searchTerm,
      taxCode,
      // action
      showView,
    };
  },
};
</script>
<style >
.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 1rem !important;
}
</style>